import PortalIdParser from 'PortalIdParser';
export const getConnectedAppUrl = () => `/integrations-settings/${PortalIdParser.get()}/installed`;